import React from "react";
import SEO from "../SEO";
import MarketingNav from "./MarketingNav";
import MarketingFooter from "./MarketingFooter";

export default function MarketingPage({ seo, children }) {
  return (
    <div className="bg-[#faf6ee] text-[#0a1736] min-h-screen flex flex-col">
      <SEO {...seo} />
      <MarketingNav />
      <main className="flex-1">{children}</main>
      <MarketingFooter />
    </div>
  );
}

export function PageHero({ eyebrow, title, italicWord, description, children }) {
  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 -z-10 opacity-60"
        style={{
          backgroundImage:
            "radial-gradient(1200px 400px at 80% -20%, rgba(45,91,255,0.10), transparent 60%)",
        }}
      />
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-16 lg:pt-24">
        {eyebrow && (
          <p className="text-[#2d5bff] font-medium text-sm tracking-wide uppercase">
            {eyebrow}
          </p>
        )}
        <h1 className="font-display text-[#0a1736] text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] mt-3 max-w-4xl">
          {title}
          {italicWord && (
            <>
              {" "}
              <span className="italic text-[#2d5bff]">{italicWord}</span>
            </>
          )}
        </h1>
        {description && (
          <p className="mt-6 text-lg text-[#5a6478] max-w-3xl leading-relaxed">
            {description}
          </p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
